import { render, staticRenderFns } from "./InvoiceBankNumber.vue?vue&type=template&id=b5899fa2&"
import script from "./InvoiceBankNumber.vue?vue&type=script&lang=js&"
export * from "./InvoiceBankNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports